import React from 'react';

const LogoSmokeball = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#2D3748"/>
    <path d="M16 16C16 13.7909 17.7909 12 20 12H28C30.2091 12 32 13.7909 32 16V32C32 34.2091 30.2091 36 28 36H20C17.7909 36 16 34.2091 16 32V16Z" fill="white"/>
    <circle cx="24" cy="20" r="3" fill="#2D3748"/>
    <circle cx="24" cy="28" r="3" fill="#2D3748"/>
    <circle cx="24" cy="32" r="2" fill="#2D3748"/>
  </svg>
);

export default LogoSmokeball;
